import React, { useState } from 'react';
import { 
  FaCog, 
  FaUser, 
  FaShieldAlt, 
  FaBell, 
  FaEnvelope, 
  FaSave,
  FaEye,
  FaEyeSlash
} from 'react-icons/fa';

const Settings = () => {
  const [activeTab, setActiveTab] = useState('profile');
  const [showPassword, setShowPassword] = useState(false);
  const [settings, setSettings] = useState({
    profile: {
      name: 'Admin User',
      email: 'admin@peaknet.com.au',
      phone: '+61 400 123 456',
      role: 'Administrator'
    },
    notifications: {
      newCustomers: true,
      paymentFailures: true,
      systemAlerts: true,
      emailNotifications: true
    },
    security: {
      twoFactorAuth: false,
      sessionTimeout: 30,
      passwordExpiry: 90
    }
  });

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log('Settings saved:', settings);
  };

  const TabButton = ({ id, label, icon }) => (
    <button
      onClick={() => setActiveTab(id)}
      className={`flex items-center space-x-3 w-full p-4 rounded-lg text-left transition-colors ${
        activeTab === id
          ? 'bg-[#fabd2f] text-[#1d2021]'
          : 'text-[#ebdbb2] hover:bg-[#3c3836]'
      }`}
    >
      {icon}
      <span className="font-medium">{label}</span>
    </button>
  );

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-[#ebdbb2]">Settings</h1>
        <p className="text-[#bdae93]">Manage your account and system preferences</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar */}
        <div className="lg:col-span-1">
          <div className="bg-[#282828] rounded-xl shadow-sm border border-[#3c3836] p-4">
            <nav className="space-y-2">
              <TabButton
                id="profile"
                label="Profile"
                icon={<FaUser size={20} />}
              />
              <TabButton
                id="notifications"
                label="Notifications"
                icon={<FaBell size={20} />}
              />
              <TabButton
                id="security"
                label="Security"
                icon={<FaShieldAlt size={20} />}
              />
            </nav>
          </div>
        </div>

        {/* Content */}
        <div className="lg:col-span-3">
          <div className="bg-[#282828] rounded-xl shadow-sm border border-[#3c3836] p-6">
            {activeTab === 'profile' && (
              <div className="space-y-6">
                <h2 className="text-2xl font-bold text-[#ebdbb2]">Profile Settings</h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-[#bdae93] mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      value={settings.profile.name}
                      onChange={(e) => setSettings({
                        ...settings,
                        profile: { ...settings.profile, name: e.target.value }
                      })}
                      className="w-full px-3 py-2 bg-[#3c3836] border border-[#504945] rounded-lg text-[#ebdbb2] placeholder-[#928374] focus:ring-2 focus:ring-[#fabd2f] focus:border-transparent"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-[#bdae93] mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      value={settings.profile.email}
                      onChange={(e) => setSettings({
                        ...settings,
                        profile: { ...settings.profile, email: e.target.value }
                      })}
                      className="w-full px-3 py-2 bg-[#3c3836] border border-[#504945] rounded-lg text-[#ebdbb2] placeholder-[#928374] focus:ring-2 focus:ring-[#fabd2f] focus:border-transparent"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-[#bdae93] mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      value={settings.profile.phone}
                      onChange={(e) => setSettings({
                        ...settings,
                        profile: { ...settings.profile, phone: e.target.value }
                      })}
                      className="w-full px-3 py-2 bg-[#3c3836] border border-[#504945] rounded-lg text-[#ebdbb2] placeholder-[#928374] focus:ring-2 focus:ring-[#fabd2f] focus:border-transparent"
                    />
                  </div>
                  
                  <div>
                    <label className="block text-sm font-medium text-[#bdae93] mb-2">
                      Role
                    </label>
                    <input
                      type="text"
                      value={settings.profile.role}
                      disabled
                      className="w-full px-3 py-2 bg-[#3c3836] border border-[#504945] rounded-lg text-[#928374]"
                    />
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'notifications' && (
              <div className="space-y-6">
                <h2 className="text-2xl font-bold text-[#ebdbb2]">Notification Preferences</h2>
                
                <div className="space-y-4">
                  <div className="flex items-center justify-between p-4 border border-[#3c3836] rounded-lg bg-[#3c3836]">
                    <div>
                      <h3 className="font-medium text-[#ebdbb2]">New Customer Signups</h3>
                      <p className="text-sm text-[#928374]">Get notified when new customers sign up</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={settings.notifications.newCustomers}
                        onChange={(e) => setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, newCustomers: e.target.checked }
                        })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-[#504945] peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#fabd2f] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-[#1d2021] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#ebdbb2] after:border-[#504945] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#fabd2f]"></div>
                    </label>
                  </div>
                  
                  <div className="flex items-center justify-between p-4 border border-[#3c3836] rounded-lg bg-[#3c3836]">
                    <div>
                      <h3 className="font-medium text-[#ebdbb2]">Payment Failures</h3>
                      <p className="text-sm text-[#928374]">Get notified when direct debits fail</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={settings.notifications.paymentFailures}
                        onChange={(e) => setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, paymentFailures: e.target.checked }
                        })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-[#504945] peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#fabd2f] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-[#1d2021] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#ebdbb2] after:border-[#504945] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#fabd2f]"></div>
                    </label>
                  </div>
                  
                  <div className="flex items-center justify-between p-4 border border-[#3c3836] rounded-lg bg-[#3c3836]">
                    <div>
                      <h3 className="font-medium text-[#ebdbb2]">System Alerts</h3>
                      <p className="text-sm text-[#928374]">Get notified about system maintenance and updates</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={settings.notifications.systemAlerts}
                        onChange={(e) => setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, systemAlerts: e.target.checked }
                        })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-[#504945] peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#fabd2f] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-[#1d2021] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#ebdbb2] after:border-[#504945] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#fabd2f]"></div>
                    </label>
                  </div>
                  
                  <div className="flex items-center justify-between p-4 border border-[#3c3836] rounded-lg bg-[#3c3836]">
                    <div>
                      <h3 className="font-medium text-[#ebdbb2]">Email Notifications</h3>
                      <p className="text-sm text-[#928374]">Receive notifications via email</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={settings.notifications.emailNotifications}
                        onChange={(e) => setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, emailNotifications: e.target.checked }
                        })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-[#504945] peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#fabd2f] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-[#1d2021] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#ebdbb2] after:border-[#504945] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#fabd2f]"></div>
                    </label>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'security' && (
              <div className="space-y-6">
                <h2 className="text-2xl font-bold text-[#ebdbb2]">Security Settings</h2>
                
                <div className="space-y-6">
                  <div className="flex items-center justify-between p-4 border border-[#3c3836] rounded-lg bg-[#3c3836]">
                    <div>
                      <h3 className="font-medium text-[#ebdbb2]">Two-Factor Authentication</h3>
                      <p className="text-sm text-[#928374]">Add an extra layer of security to your account</p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={settings.security.twoFactorAuth}
                        onChange={(e) => setSettings({
                          ...settings,
                          security: { ...settings.security, twoFactorAuth: e.target.checked }
                        })}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-[#504945] peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#fabd2f] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-[#1d2021] after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-[#ebdbb2] after:border-[#504945] after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#fabd2f]"></div>
                    </label>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-[#bdae93] mb-2">
                        Session Timeout (minutes)
                      </label>
                      <select
                        value={settings.security.sessionTimeout}
                        onChange={(e) => setSettings({
                          ...settings,
                          security: { ...settings.security, sessionTimeout: parseInt(e.target.value) }
                        })}
                        className="w-full px-3 py-2 bg-[#3c3836] border border-[#504945] rounded-lg text-[#ebdbb2] focus:ring-2 focus:ring-[#fabd2f] focus:border-transparent"
                      >
                        <option value={15}>15 minutes</option>
                        <option value={30}>30 minutes</option>
                        <option value={60}>1 hour</option>
                        <option value={120}>2 hours</option>
                      </select>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-[#bdae93] mb-2">
                        Password Expiry (days)
                      </label>
                      <select
                        value={settings.security.passwordExpiry}
                        onChange={(e) => setSettings({
                          ...settings,
                          security: { ...settings.security, passwordExpiry: parseInt(e.target.value) }
                        })}
                        className="w-full px-3 py-2 bg-[#3c3836] border border-[#504945] rounded-lg text-[#ebdbb2] focus:ring-2 focus:ring-[#fabd2f] focus:border-transparent"
                      >
                        <option value={30}>30 days</option>
                        <option value={60}>60 days</option>
                        <option value={90}>90 days</option>
                        <option value={180}>180 days</option>
                      </select>
                    </div>
                  </div>
                  
                  <div className="p-4 bg-[#3c3836] border border-[#d79921] rounded-lg">
                    <h3 className="font-medium text-[#fabd2f] mb-2">Security Recommendations</h3>
                    <ul className="text-sm text-[#bdae93] space-y-1">
                      <li>• Enable two-factor authentication for enhanced security</li>
                      <li>• Use a strong, unique password</li>
                      <li>• Regularly update your password</li>
                      <li>• Log out when using shared computers</li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {/* Save Button */}
            <div className="flex justify-end pt-6 border-t border-[#3c3836]">
              <button
                onClick={handleSave}
                className="px-6 py-2 bg-[#fabd2f] text-[#1d2021] rounded-lg hover:bg-[#fe8019] transition-colors flex items-center space-x-2 font-medium"
              >
                <FaSave size={16} />
                <span>Save Changes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings; 